import React, { useState } from "react";
import { Modal } from "react-bootstrap";

import LinkedUsersTable from "./linkedUserTable";
import UnlinkedUsersTable from "./unlinkedUsersTable";

import styles from "./ssoIdUsersModal.module.scss";

type PropsType = {
	show: boolean;
	onHide: () => void;
	showEditBtn: boolean;
	userFullName?: string;
	email?: string;
	userId: string;
	fusionAuthUserId: string;
	refetchUser?: Function;
};

const SsoIdUsersModal = ({
	userId,
	userFullName,
	fusionAuthUserId,
	refetchUser,
	show,
	onHide,
	email,
}: PropsType) => {
	const [isUserLinked, setIsUserLinked] = useState<boolean>(
		!!fusionAuthUserId,
	);

	return (
		<Modal
			show={show}
			onHide={onHide}
			centered
			className={styles.ssoIdUsersModal}
		>
			<Modal.Header closeButton className="pb-0">
				<Modal.Title className="text-center">SSO ID</Modal.Title>
			</Modal.Header>
			<Modal.Body className={styles.content}>
				{isUserLinked ? (
					<LinkedUsersTable
						userId={userId}
						userFullName={userFullName}
						setIsUserLinked={setIsUserLinked}
						refetchUser={refetchUser}
						email={email}
					/>
				) : (
					<UnlinkedUsersTable
						userId={userId}
						hideModal={onHide}
						refetchUser={refetchUser}
					/>
				)}
			</Modal.Body>
		</Modal>
	);
};

export default SsoIdUsersModal;
